import React from 'react';

const ReadOnlyConfigSetting = ({ configdata }) => {
    return (
        <div className="config-setting-container">
            <section className="section">
                <div className="row">
                    <h5 className="text-pink mb-3" style={{ fontSize: '18px', fontWeight: '700' }}>Discount Configuration</h5>

                    <div className="col-md-6 mb-4">
                        <div className="card">
                            <div className="card-header">One-Off Services (Single Service)</div>
                            <div className="card-body pt-4">
                                <div className="row align-items-center">
                                    <label className="col-sm-3 col-form-label">Discount value:</label>
                                    <div className="col-sm-9">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={configdata?.discount_oneoff_single ?? ''}
                                            disabled
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 mb-4">
                        <div className="card">
                            <div className="card-header">One-Off Services (Multiple Services)</div>
                            <div className="card-body pt-4">
                                <div className="row align-items-center">
                                    <label className="col-sm-3 col-form-label">Discount value:</label>
                                    <div className="col-sm-9">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={configdata?.discount_oneoff_multiple ?? ''}
                                            disabled
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 mb-4">
                        <div className="card">
                            <div className="card-header">Ongoing Services (Single Service)</div>
                            <div className="card-body pt-4">
                                <div className="row align-items-center">
                                    <label className="col-sm-3 col-form-label">Discount value:</label>
                                    <div className="col-sm-9">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={configdata?.discount_ongoing_single ?? ''}
                                            disabled
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 mb-4">
                        <div className="card">
                            <div className="card-header">Ongoing Services (Multiple Services)</div>
                            <div className="card-body pt-4">
                                <div className="row align-items-center">
                                    <label className="col-sm-3 col-form-label">Discount value:</label>
                                    <div className="col-sm-9">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={configdata?.discount_ongoing_multiple ?? ''}
                                            disabled
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <h5 className="text-pink mb-3" style={{ fontSize: '18px', fontWeight: '700' }}>Multipliers</h5>
                    <div className="col-md-6 mb-4">
                        <div className="card">
                            <div className="card-header">Complexity & Risk</div>
                            <div className="card-body pt-4">
                                {['low', 'medium', 'high'].map(level => (
                                    <div className="row align-items-center mb-3" key={level}>
                                        <label className="col-sm-3 col-form-label">{level.charAt(0).toUpperCase() + level.slice(1)}:</label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={configdata[`complexity_${level}`] ?? ''}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 mb-4">
                        <div className="card">
                            <div className="card-header">Quality of Data</div>
                            <div className="card-body pt-4">
                                {[
                                    { key: "low", label: "Good" },
                                    { key: "medium", label: "Average" },
                                    { key: "high", label: "Poor" },
                                ].map(item => (
                                    <div className="row align-items-center mb-3" key={item.key}>
                                        <label className="col-sm-3 col-form-label">{item.label}:</label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={configdata[`quality_data_${item.key}`] ?? ''}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 mb-4">
                        <div className="card">
                            <div className="card-header">Frequency of meetings & Access to Seniors/ Experts</div>
                            <div className="card-body pt-4">
                                {['low', 'medium', 'high'].map(level => (
                                    <div className="row align-items-center mb-3" key={level}>
                                        <label className="col-sm-3 col-form-label">{level.charAt(0).toUpperCase() + level.slice(1)}:</label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={configdata[`frequency_meeting_${level}`] ?? ''}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <h5 className="text-pink mb-3" style={{ fontSize: '18px', fontWeight: '700' }}>Payment Type & Contract Type</h5>

                    <div className='d-flex gap-4'>
                        <div className="col-md-6 mb-4">
                            <div className="card">
                                <div className="card-header">Payment Type</div>
                                <div className="card-body pt-4">
                                    <div className="row align-items-center">
                                        <label className="col-sm-3 col-form-label">Non DD:</label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={configdata?.payment_type_non_dd ?? ''}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="card-body">
                                    <div className="row align-items-center">
                                        <label className="col-sm-3 col-form-label">DD:</label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={configdata?.payment_type_dd ?? ''}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="card-body">
                                    <div className="row align-items-center">
                                        <label className="col-sm-3 col-form-label">Upfront:</label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={configdata?.payment_type_upfront ?? ''}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="card-body">
                                    <div className="row align-items-center">
                                        <label className="col-sm-3 col-form-label">50-50:</label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={configdata?.payment_type_50_50 ?? ''}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="card-body">
                                    <div className="row align-items-center">
                                        <label className="col-sm-3 col-form-label">Quarterly DD:</label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={configdata?.quarterly_dd ?? ''}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 mb-4">
                            <div className="card">
                                <div className="card-header">Contract Type</div>
                                <div className="card-body pt-4">
                                    <div className="row align-items-center">
                                        <label className="col-sm-3 col-form-label">Ongoing Service:</label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={configdata?.contract_type_ongoing ?? ''}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="card-body">
                                    <div className="row align-items-center">
                                        <label className="col-sm-3 col-form-label">One off Service:</label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={configdata?.contract_type_oneoff ?? ''}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="card-body">
                                    <div className="row align-items-center">
                                        <label className="col-sm-3 col-form-label">PAYG:</label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={configdata?.contract_type_payg ?? ''}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ReadOnlyConfigSetting;
